export default __webpack_public_path__ + "static/media/fisheye.208ebf1d.jpg";